/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_Injury_FreeInputs */

const en_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play Injury Free`)
};

const es_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juega sin lesiones`)
};

const de_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spielen Sie verletzungsfrei`)
};

const zh_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无伤打球`)
};

const ar_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العب بلا إصابات`)
};

const fr_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouer sans blessure`)
};

const vi_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chơi không chấn thương`)
};

const sw_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cheza Bila Majeraha`)
};

const th_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เล่นแบบไร้อาการบาดเจ็บ`)
};

const bs_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Igraj bez povreda`)
};

const ja_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ケガなくプレー`)
};

const ko_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`부상 없이 플레이`)
};

const pt_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogue sem lesões`)
};

const it_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gioca senza infortuni`)
};

const sv_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spela skadefritt`)
};

const nl_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speel zonder blessures`)
};

const da_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spil skadefrit`)
};

const nb_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spill skadefritt`)
};

const fi_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelaa ilman vammoja`)
};

const pl_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Graj bez kontuzji`)
};

const ru_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Играйте без травм`)
};

const tr_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sakatlanmadan oyna`)
};

const hi_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चोट के बिना खेलें`)
};

const id_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bermain tanpa cedera`)
};

const ms_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bermain Tanpa Kecederaan`)
};

const cs_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hrajte bez zranění`)
};

const el_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Παίξτε χωρίς τραυματισμούς`)
};

const he_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שחקו ללא פציעות`)
};

const af_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speel sonder beserings`)
};

const hu_footer_link_injury_free = /** @type {(inputs: Footer_Link_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Játssz sérülés nélkül`)
};

/**
* | output |
* | --- |
* | "Play Injury Free" |
*
* @param {Footer_Link_Injury_FreeInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const footer_link_injury_free = /** @type {((inputs?: Footer_Link_Injury_FreeInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_Injury_FreeInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_link_injury_free(inputs)
	if (locale === "de") return de_footer_link_injury_free(inputs)
	if (locale === "zh") return zh_footer_link_injury_free(inputs)
	if (locale === "ar") return ar_footer_link_injury_free(inputs)
	if (locale === "fr") return fr_footer_link_injury_free(inputs)
	if (locale === "vi") return vi_footer_link_injury_free(inputs)
	if (locale === "sw") return sw_footer_link_injury_free(inputs)
	if (locale === "th") return th_footer_link_injury_free(inputs)
	if (locale === "bs") return bs_footer_link_injury_free(inputs)
	if (locale === "ja") return ja_footer_link_injury_free(inputs)
	if (locale === "ko") return ko_footer_link_injury_free(inputs)
	if (locale === "pt") return pt_footer_link_injury_free(inputs)
	if (locale === "it") return it_footer_link_injury_free(inputs)
	if (locale === "sv") return sv_footer_link_injury_free(inputs)
	if (locale === "nl") return nl_footer_link_injury_free(inputs)
	if (locale === "da") return da_footer_link_injury_free(inputs)
	if (locale === "nb") return nb_footer_link_injury_free(inputs)
	if (locale === "fi") return fi_footer_link_injury_free(inputs)
	if (locale === "pl") return pl_footer_link_injury_free(inputs)
	if (locale === "ru") return ru_footer_link_injury_free(inputs)
	if (locale === "tr") return tr_footer_link_injury_free(inputs)
	if (locale === "hi") return hi_footer_link_injury_free(inputs)
	if (locale === "id") return id_footer_link_injury_free(inputs)
	if (locale === "ms") return ms_footer_link_injury_free(inputs)
	if (locale === "cs") return cs_footer_link_injury_free(inputs)
	if (locale === "el") return el_footer_link_injury_free(inputs)
	if (locale === "he") return he_footer_link_injury_free(inputs)
	if (locale === "af") return af_footer_link_injury_free(inputs)
	if (locale === "hu") return hu_footer_link_injury_free(inputs)
	return en_footer_link_injury_free(inputs)
});